import { canView } from '@/shared/lib/permissions';
import { useAuthStore } from '@/shared/stores/auth';
import { Cdr } from './Cdr';
import { AdminVoicemail } from './Voicemail';

/**
 * "שיחות" — יומן השיחות (CDR). "תא קולי" היא לשונית בבורר המקטעים של היומן
 * (עיצוב v2, 28/09/2026). /admin/voicemail מפנה לכאן עם ?tab=voicemail.
 */
export function CallsCenter() {
  const user = useAuthStore((s) => s.user);
  const canCdr = canView(user, 'cdr');
  const canVm = canView(user, 'voicemail');

  // בלי הרשאת יומן — רק התא הקולי, כמסך עצמאי.
  if (!canCdr && canVm) return <AdminVoicemail />;
  return <Cdr voicemail={canVm ? <AdminVoicemail embedded /> : undefined} />;
}
